import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mobile-arrow-right-gray",
  "use": "icon-mobile-arrow-right-gray-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mobile-arrow-right-gray\">\n    <path d=\"M5 1.2 11.8 8 5 14.803v-1.415l5.386-5.386L5 2.615z\" fill=\"#DDD\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol